/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import AOS from 'aos';
import LazyLoad from "vanilla-lazyload";
import Swiper from 'swiper/bundle';
import Player from '@vimeo/player';
import { prepareScene, loadObject } from 'js-3d-model-viewer';

$(document).ready(() => {
  AOS.init();

  // Vimeo player
  if( $('#video').length ) {
    const video = $('#video');
    const player = new Player(video);

    player.on('pause', function() {
        $('.section-video__backdrop').hide();
        $('.section-video__backdrop').show();
    });

    $('.section-video__play-button').click( function () {
      $('.section-video__backdrop').hide();
      player.play();
    });
  }

  var lazyLoadInstance = new LazyLoad({
    threshold: 100,
  });

  const builderSwiper = new Swiper('.slider .swiper-container.swiper-enabled', {
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  window.addEventListener("load", function(){
    var viewerElement = document.getElementById('viewer')
    var scene = prepareScene(viewerElement)
      loadObject(scene,
        '/app/themes/touchlight/resources/assets/3d/enzyme_v1.obj',
        '/app/themes/touchlight/resources/assets/3d/enzyme_v1.mtl',
      )
  });

  // Add class to header when menu is open so that we can add a background
  $('.navbar-toggler').click(function(){
    $('.header').toggleClass('menu-open');
  });

  $(window).on("scroll", function() {
    if($(window).scrollTop() > 50) {
        $("body").addClass("scroll-down");
    } else {
        //remove the background property so it comes transparent again (defined in your css)
       $("body").removeClass("scroll-down");
    }
  });

  $(window).on("load", function() {
    if($(window).scrollTop() > 50) {
        $("body").addClass("scroll-down");
    } else {
        //remove the background property so it comes transparent again (defined in your css)
       $("body").removeClass("scroll-down");
    }
  });

  $(() => {
    $('.faux-filters a').each(function() {
      if ( window.location.href.replace(/page\/\d+\//, '').endsWith($(this).attr('href')) ) {
        $(this).parent().addClass('active');
        $(this).children('.custom-control-input').prop('checked', true);
      }
    })
  })

  $(() => {
    /**
     * initMap
     *
     * Renders a Google Map onto the selected jQuery element
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @return  object The map instance.
     */
    function initMap( $el ) {

      var styles = [
        {
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#f5f5f5"
            }
          ]
        },
        {
          "elementType": "labels.icon",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#616161"
            }
          ]
        },
        {
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "color": "#f5f5f5"
            }
          ]
        },
        {
          "featureType": "administrative.land_parcel",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#bdbdbd"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#eeeeee"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#757575"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#e5e5e5"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#9e9e9e"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#ffffff"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#757575"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#dadada"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#616161"
            }
          ]
        },
        {
          "featureType": "road.local",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#9e9e9e"
            }
          ]
        },
        {
          "featureType": "transit.line",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#e5e5e5"
            }
          ]
        },
        {
          "featureType": "transit.station",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#eeeeee"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#e5e4e3"
            },
            {
              "saturation": -100
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#9e9e9e"
            }
          ]
        }
      ];

      // Find marker elements within map.
      var $markers = $el.find('.marker');

      // Create gerenic map.
      var mapArgs = {
        zoom        : $el.data('zoom') || 16,
        mapTypeId   : google.maps.MapTypeId.ROADMAP,
        styles      : styles
      };
      var map = new google.maps.Map( $el[0], mapArgs );

      // Add markers.
      map.markers = [];
      $markers.each(function(){
        initMarker( $(this), map );
      });

      // Center map based on markers.
      centerMap( map );

      // Return map instance.
      return map;
    }

    /**
     * initMarker
     *
     * Creates a marker for the given jQuery element and map.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @param   object The map instance.
     * @return  object The marker instance.
     */
    function initMarker( $marker, map ) {

      // Get position from marker.
      var lat = $marker.data('lat');
      var lng = $marker.data('lng');
      var latLng = {
        lat: parseFloat( lat ),
        lng: parseFloat( lng )
      };

      var markerIcon = $marker.data('icon');

      // Create marker instance.
      var marker = new google.maps.Marker({
        position : latLng,
        map: map,
        icon: markerIcon
      });

      // Append to reference for later use.
      map.markers.push( marker );

      // If marker contains HTML, add it to an infoWindow.
      if( $marker.html() ){

        // Create info window.
        var infowindow = new google.maps.InfoWindow({
          content: $marker.html()
        });

        // Show info window when marker is clicked.
        google.maps.event.addListener(marker, 'click', function() {
          infowindow.open( map, marker );
        });
      }
    }

    /**
     * centerMap
     *
     * Centers the map showing all markers in view.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   object The map instance.
     * @return  void
     */
    function centerMap( map ) {

      // Create map boundaries from all map markers.
      var bounds = new google.maps.LatLngBounds();
      map.markers.forEach(function( marker ){
        bounds.extend({
          lat: marker.position.lat(),
          lng: marker.position.lng()
        });
      });

      // Case: Single marker.
      if( map.markers.length == 1 ){
        map.setCenter( bounds.getCenter() );

        // Case: Multiple markers.
      } else{
        map.fitBounds( bounds );
      }
    }

    // Render maps on page load.
    $(document).ready(function(){
      $('.acf-map').each(function(){
        var map = initMap( $(this) );
      });
    });
  })

  // Show first tab in people tabs
  $('#peopleTab li:first-child a').tab('show');

  // Show opened market and service collapsed content on page load
  $(function(){
    $(document).ready(function() {
      if (window.location.hash) {
        // Grab hash from URL
        let urlHash = location.hash;

        // Animate scroll to anchor incorporating fixed header height
        //let headerHeight = $('header').outerHeight();
        $('html, body').animate({scrollTop: $(location.hash).offset().top - -120}, 0);

        // Remove class and set main market service panel to show open style
        $(urlHash+' .panel__item').removeClass('collapsed');
        $(urlHash+' .panel__item').attr('aria-expanded', 'true');

        // Show collapsed content for market service of element ID from hash
        $(urlHash).next('.js-flex-dropdown').find('div').addClass('show');

        // Remove class and set service accordion to show open style
        $(urlHash+' .services-accordion__header').removeClass('collapsed');
        $(urlHash+' .services-accordion__header').attr('aria-expanded', 'true');

        // Show collapsed content for market service of element ID from hash
        $(urlHash+' > .panel__dropdown').addClass('show');
      }
    });
  });

  const $dropdown = $("#navbar .dropdown");
  const $dropdownToggle = $("#navbar .dropdown-toggle");
  const $dropdownMenu = $("#navbar .dropdown-menu");
  const showClass = "show";

  $(window).on("load resize", function() {
    if (this.matchMedia("(min-width: 992px)").matches) {
      $dropdown.hover(
        function() {
          const $this = $(this);
          $this.addClass(showClass);
          $this.find($dropdownToggle).attr("aria-expanded", "true");
          $this.find($dropdownMenu).addClass(showClass);
        },
        function() {
          const $this = $(this);
          $this.removeClass(showClass);
          $this.find($dropdownToggle).attr("aria-expanded", "false");
          $this.find($dropdownMenu).removeClass(showClass);
        }
      );
    } else {
      $dropdown.off("mouseenter mouseleave");
      $dropdownToggle.click(
        function(e) {
          const $this = $(this);
          if($this.hasClass(showClass)){
            const $this = $(this);
            e.preventDefault();
            $this.removeClass(showClass);
            $this.attr("aria-expanded", "false");
            $this.next($dropdownMenu).removeClass(showClass);
          } else {
            const $this = $(this);
            e.preventDefault();
            $this.addClass(showClass);
            $this.attr("aria-expanded", "true");
            $this.next($dropdownMenu).removeClass(showClass);
            $this.next($dropdownMenu).addClass(showClass);
          }
        },
      );
    }
  });

  // Conditional check to hide KC featured posts if filters used.
  let url = window.location.href;

  if (url.indexOf('?') !== -1 || url.match(/knowledge-centre\/\w+/)){
    $('section.featured-posts').hide();
    $('.knowledge-centre .news h4').text('Search results');
  } else {
    $('section.featured-posts').show();
    $('.knowledge-centre .news h4').text('Recent posts');
  }

  /*
   * Scroll to position of opened service accordion
   */
  $('.collapse').on('shown.bs.collapse', function() {
    let $card = $(this).closest('.card');
    $('html, body').animate({
      scrollTop: $card.offset().top - -120
    }, 1000);
  });
});

/**
 * Meet the team dropdowns
 */
 $(() => {

  const SNAP_LG = 992;
  const SNAP_SM = 767;

  /**
   * Fixes the flex order so the people dropdown appears in the right place.
   */
  const fixFlexOrder = () => {
    let j = 0;
    $('.js-flex-reorder>.js-flex-panel').each((i, el) => {
      const $panel = $(el);
      const $dropdown = $(el).next();
      const windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      const divisor = windowWidth > SNAP_LG ? 3 : windowWidth < SNAP_SM ? 1 : 2;
      const rowOrder = Math.ceil((j + 1) / divisor);
      if ( $panel.is(':visible') ) {
        // Fix flex
        $panel.css('order', rowOrder).addClass('is-number-' + (j+1));
        $dropdown.css('order', rowOrder + 1);
        j++;
      } else {
        // Reset everything else to zero
        $panel.css('order', 0);
        $dropdown.css('order', 0);
      }
    });
  };

  $('.people__nav li:first-child a[data-filter]').addClass('active');
  const teamFilterFirst = $('.people__nav li:first-child a[data-filter]').attr('data-filter');
  $('[data-teams]').hide();
  $(`[data-teams*="${teamFilterFirst}"]`).show();

  fixFlexOrder();

  $('a[data-filter]').on('click', function(){
    // Close any stray open person dropdowns
    $('section.people .collapse').collapse('hide');

    // Hide everything
    $('[data-teams]').hide();

    // Remove active class to link if it has one
    $('a[data-filter]').removeClass('active');

    // Add active class to link
    $(this).addClass('active');

    // Show according to filters
    const teamFilter = $(this).attr('data-filter');
    $(`[data-teams*="${teamFilter}"]`).show();

    // Re-apply flex order fix
    fixFlexOrder();
  })
});

/**
 * Year filter on the news and events page
 */
$(() => {
   $('#filter-date').on('change', function(){
     const $val = $(this).val(),
       currentPath = window.location.pathname,
       currentQuerystring = window.location.search;
     let newQuerystring = '';
     if ( $val.match(/\d{4}/) ) {
       let qs = `year=${$val}`;
       if ( currentQuerystring.match(/year=\d{4}/) ) {
         newQuerystring = currentQuerystring.replace(/year=\d{4}/, qs)
       } else if ( currentQuerystring === '' ) {
         newQuerystring = qs
       } else {
         newQuerystring = `${currentQuerystring}&${qs}`
       }
     } else {
       newQuerystring = currentQuerystring.replace(/year=\d{4}/, '');
     }
     window.location.href = `${currentPath}?${newQuerystring}`
   })
 })

/**
 * Careers filters
 */

$(() => {
  const $types = $('[data-filter="type"]');
  const $locations = $('[data-filter="location"]');

  const cartesianProduct = (a, b) => {
    if (a.length === 0) return b;
    if (b.length === 0) return a;
    const product = [];
    for (const aa of a) {
      for (const bb of b) {
        product.push([aa, bb].join(''));
      }
    }
    return product;
  }

  const checkboxHandler = function($checkboxes){
    const $self = $(this);

    // Prevent multiple selections of all and something else
    if ( $self.is(':checked') ) {
      if ( $self.val() === 'all' ) {
        // We just checked "all" so uncheck everything else
        $checkboxes.filter('[value!=all]').prop('checked', false);
      } else {
        // We just checked one of the other types, so uncheck "all"
        $checkboxes.filter('[value=all]').prop('checked', false);
      }
    }

    // Prevent nothing from being checked at all
    if ( !$checkboxes.filter(':checked').length ) {
      $checkboxes.filter('[value=all]').prop('checked', true);
    }

    // Hide all careers
    $('.section-careers .career').hide();

    // Process resulting checkbox states to generate jq selectors
    let typesFilter = [], locationsFilter = [];
    $types.filter(':checked').each(function(){
      typesFilter.push(`[data-types*='${$(this).val()}']`);
    });
    $locations.filter(':checked').each(function(){
      locationsFilter.push(`[data-locations*='${$(this).val()}']`);
    });

    $(cartesianProduct(typesFilter, locationsFilter).join()).show();
  };

  $types.on('change', function(){
    checkboxHandler.call(this, $types)
  });
  $locations.on('change', function(){
    checkboxHandler.call(this, $locations);
  });

});

/**
 * Knowledge Centre filters
 */

$(() => {
  if ( !$('body').hasClass('knowledge-centre') ) {
    return;
  }

  const $types = $('[data-filter="type"]');

  const checkboxHandler = function($checkboxes){
    const $self = $(this);

    // Prevent multiple selections of all and something else
    if ( $self.is(':checked') ) {
      if ( $self.val() === 'all' ) {
        // We just checked "all" so uncheck everything else
        $checkboxes.filter('[value!=all]').prop('checked', false);
      } else {
        // We just checked one of the other types, so uncheck "all"
        $checkboxes.filter('[value=all]').prop('checked', false);
      }
    }

    // Prevent nothing from being checked at all
    if ( !$checkboxes.filter(':checked').length ) {
      $checkboxes.filter('[value=all]').prop('checked', true);
    }


    // Process resulting checkbox states to generate jq selectors
    let typesFilter = [];
    $types.filter(':checked').each(function(){
      typesFilter.push($(this).val());
    });

    let typesQuery = typesFilter.join();

    const currentPath = window.location.pathname,
      currentQuerystring = window.location.search.replace('?', '');
    let newQuerystring = '';
    if ( typesQuery !== 'all' ) {
      let qs = `types=${typesQuery}`;
      if ( currentQuerystring.match(/types=[^&]+/) ) {
        newQuerystring = currentQuerystring.replace(/types=[^&]+/, qs)
      } else if ( currentQuerystring === '' ) {
        newQuerystring = qs
      } else {
        newQuerystring = `${currentQuerystring}&${qs}`
      }
    } else {
      newQuerystring = currentQuerystring.replace(/types=[^&]+/, '');
    }
    window.location.href = `${currentPath}?${newQuerystring}`

  };

  $types.on('change', function(){
    checkboxHandler.call(this, $types)
  });
})

/**
 * HubSpot gated content
 */
$(() => {
  // Gated form callback event to redirect and hide modal after submission
  if ($('body').hasClass('single-knowledge_centre')){
    window.addEventListener('message', event => {
      if(event.data.id === '0335931e-529f-41c7-b409-659fc333bae5' && event.data.eventName === 'onFormSubmit') {
        $('#gated-modal').modal('hide');
      }
    });
  } else {
    window.addEventListener('message', event => {
      if(event.data.id === '0335931e-529f-41c7-b409-659fc333bae5' && event.data.eventName === 'onFormSubmit') {
        let $formRedirectUrl = $('.form-redirect-url').data('form-redirect');
        $('.modal').modal('hide');
        window.open($formRedirectUrl, '_blank');
      }
    });
  }

  // Show gated form modal for knowledge centre posts on page load
  $(document).ready(function(){
    $('#gated-modal').modal('show');
  });
})
